export enum AuditStatus {
	"PREPARING" = 1,
	"READY" = 4,
	"IN_PROGRESS" = 5,
	"RESTORABLE" = 6,
	"RESTORED" = 7
}

export enum Warning {
	MissingInstitutions,
	MissingFiles,
	MissingMapping,
	MissingData,
	MissingDateRestored,
	MissingComment,
	MissingReports,
	HavePaySlipInErrorNotVisited,
	HavePaySlipMissingData
}
